export enum InputTypeEnum {
  EMAIL = 'email',
  PHONE = 'phone',
  PHONE2 = 'phone2',
  COUNTRY = 'country',
  ADDRESS = 'streetName',
  POSTALCODE = 'postalCode',
  TOWN = 'town'
}
